import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

type ItemProps = {
  isSelected: boolean
  count?: number | string
}

export const ItemsContainer = styled.div`
  position: relative;
  overflow-y: scroll;
  max-height: calc(100vh - 334px);
  margin-bottom: 10px;

  /* the web dialog scrolls itself — an inner viewport-derived cap only forces
     a second scrollbar around the variant grid */
  ${media.web} {
    overflow-y: visible;
    max-height: none;
  }
`

export const ItemsGrid = styled.div`
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 120px;
  grid-gap: 10px;
  position: relative;
  &:after {
    content: unset;
  }

  /* wrap options onto new rows instead of stretching or scrolling */
  ${media.web} {
    overflow-y: visible;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    grid-template-rows: none;
    grid-auto-rows: 120px;
  }
`
export const ItemsGridExpander = styled.div`
  position: absolute;
  background-image: linear-gradient(
    transparent,
    ${({ theme }) => theme.MainBackGround}
  );
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: unset;
  }
`

export const MainTitle = styled.div`
  text-align: center;
  margin: 10px 0;
  color: ${({ theme }) => `${theme.FontColor}`};
`
export const Item = styled('div')<ItemProps>`
  height: 120px;
  border: ${({ theme, isSelected }) =>
    isSelected
      ? `1px solid ${theme.colour || '#34CB9E'}`
      : `1px solid ${theme.ItemsBorders}`};

  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;

  background-color: ${({ theme }) => theme.ItemsBackGround};

  &:after {
    content: ${({ count }) => (count ? `'${count}'` : 'unset')};
    color: #fff;
    font-size: 12px !important;
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${({ theme }) => theme.colour};
    height: 25px;
    /* width: 25px; */
    padding: 0 11px;
    border-radius: 0 0 0 13px;
    text-align: center;
    line-height: 25px;
  }
  p {
    margin: 0;
    font-weight: 500;
    font-size: 10px !important;
    line-height: 18px;
    color: #434343;
    text-align: center;
  }
`

export const ItemImageContainer = styled.div<{ isRounded: boolean }>`
  height: 60px;
  min-height: 60px;
  width: 60px;
  position: relative;
  box-sizing: border-box;
  /* background: #b0b0b0; */
  border-radius: ${({ isRounded }) => (isRounded ? '100%' : '0')};
  overflow: hidden;
  margin: 12px 0 0;
`

export const ItemImage = styled.img`
  height: 100%;
  object-fit: cover;
  min-height: 100%;
  min-width: 100%;
`

export const ItemPrice = styled.p`
  color: ${({ theme }) => `${theme.FontColor} !important`};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`
